import { render, staticRenderFns } from "./requestApiTest .vue?vue&type=template&id=6828801e"
import script from "./requestApiTest .vue?vue&type=script&lang=js"
export * from "./requestApiTest .vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports